<!-- Header -->
<div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px; border-bottom: 2px solid #bbf7d0; display: flex; align-items: center; justify-content: space-between;">
  <div style="display: flex; align-items: center; gap: 10px;">
    <mat-icon style="color: #1C593D; font-size: 24px; width: 24px; height: 24px;">assignment_ind</mat-icon>
    <h2 style="margin: 0; font-size: 1.15rem; font-weight: 700; color: #1e5a3f;">Asignación Roles de usuario</h2>
  </div>
  <button type="button" (click)="dialogRef.close(false)"
    style="display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: 1px solid #d1d5db; border-radius: 8px; background: white; cursor: pointer;"
    onmouseover="this.style.background='#fef2f2'" onmouseout="this.style.background='white'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">close</mat-icon>
  </button>
</div>

<!-- Body -->
<div style="padding: 24px;">
  <!-- Selected users badge -->
  <div *ngIf="data.length > 0" style="display: flex; align-items: center; gap: 8px; margin-bottom: 20px; padding: 10px 14px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px;">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #16a34a;">group</mat-icon>
    <span style="font-size: 0.85rem; font-weight: 600; color: #1e5a3f;">{{ data.length }} usuario(s) seleccionado(s)</span>
  </div>

  <div style="display: flex; flex-direction: column; gap: 16px;">
    <mat-form-field appearance="outline" class="modern-field w-full">
      <mat-label>Tipo de usuario</mat-label>
      <mat-select [(ngModel)]="segmentationId" name="segmentationId">
        <mat-option [value]="1">Retail</mat-option>
        <mat-option [value]="2">Mayorista</mat-option>
        <mat-option [value]="3">Super Mayorista</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="modern-field w-full">
      <mat-label>Puntos spot</mat-label>
      <input matInput appOnlynumber type="number" placeholder="Ej: 0.1" name="spotPoints"
        [(ngModel)]="spotPoints" [disabled]="segmentationId == 1">
    </mat-form-field>

    <!-- Warning: Retail no tiene puntos -->
    <div *ngIf="segmentationId == 1"
      style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #fef3c7; border: 1px solid #fde68a; border-radius: 10px;">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #f59e0b;">info</mat-icon>
      <span style="font-size: 0.8rem; font-weight: 600; color: #92400e;">No se asignan puntos spot al usuario Retail</span>
    </div>

    <!-- Warning: Puntos requeridos -->
    <div *ngIf="+segmentationId !== 1 && +spotPoints === 0"
      style="display: flex; align-items: center; gap: 8px; padding: 10px 14px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px;">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">warning</mat-icon>
      <span style="font-size: 0.8rem; font-weight: 600; color: #991b1b;">Debe ingresar puntos spot para este tipo de usuario</span>
    </div>
  </div>
</div>

<!-- Footer -->
<div style="padding: 16px 24px; border-top: 1px solid #e5e7eb; display: flex; justify-content: flex-end; gap: 10px; flex-wrap: wrap;">
  <button type="button" (click)="dialogRef.close(false)"
    style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
    onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
    Cancelar
  </button>
  <button type="button" (click)="editSegmentation()"
    [disabled]="!segmentationId || (+segmentationId !== 1 && +spotPoints === 0)"
    [style.opacity]="!segmentationId || (+segmentationId !== 1 && +spotPoints === 0) ? '0.5' : '1'"
    [style.cursor]="!segmentationId || (+segmentationId !== 1 && +spotPoints === 0) ? 'not-allowed' : 'pointer'"
    style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; transition: background 0.2s ease;"
    onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">check</mat-icon>
    Asignar
  </button>
</div>
